export default {
  title: 'Калькулятор платежей',
  description: 'Расчитайте примерные платежи по ипотеке или рассрочке',
  compute: 'Рассчитать',
  hide: 'Скрыть',
  mortgage: 'Ипотека',
  installment: 'Рассрочка',
  labels: {
    price: 'Стоимость квартиры',
    dates: 'Срок платежей',
    initialPayment: 'Первоначальный взнос',
    percent: 'Процентная ставка'
  },
  expiryDateDefault: 'Закроете ипотеку',
  expiryDateInstallment: 'Закроете рассрочку',
  monthlyPayment: 'Ежемесячный платеж',
  monthlyPaymentValue: '{price} ₽',
  dates: {
    0: 'В январе {year}',
    1: 'В феврале {year}',
    2: 'В марте {year}',
    3: 'В апреле {year}',
    4: 'В мае {year}',
    5: 'В июне {year}',
    6: 'В июле {year}',
    7: 'В августе {year}',
    8: 'В сентябре {year}',
    9: 'В октябре {year}',
    10: 'В ноябре {year}',
    11: 'В декабре {year}'
  }
}
